import { Stage } from "../config/config"
import common from "./sites/common"
import SafetyNonProd from "./sites/safety-nonprod"
import SafetyProd from "./sites/safety-prod"
import QualityNonProd from "./sites/quality-nonprod"
import QualityProd from "./sites/quality-prod"
import SustainabilityNonProd from "./sites/sustainability-nonprod"
import SustainabilityProd from "./sites/sustainability-prod"

const configMap = {
  "safety-community-hub": {
    dev: SafetyNonProd,
    test: SafetyNonProd,
    prod: SafetyProd
  },
  "quality-hub": {
    dev: QualityNonProd,
    test: QualityNonProd,
    prod: QualityProd
  },
  "sustainability-hub": {
    dev: SustainabilityNonProd,
    test: SustainabilityNonProd,
    prod: SustainabilityProd
  }
}

const makeSiteConfig = (o) => {
  return {
    ...common,
    "label": o.LABEL,
    "siteId": o.SITE_ID,
    baseSitePath: `${common.baseSitePath}/${o.SITE}`,
    "urls": {
      "baseSite": `${common.domain}${common.baseSitePath}/${o.SITE}`
    },
    "listIds": {
      "pages": o.PAGES_LIST_ID,
      "documents": o.DOCUMENTS_LIST_ID,
      "documentLibrary": o.DOCUMENTS_LIST_ID
    },
    "driveIds": {
      "SiteAssets": o.SITE_ASSETS_DRIVE_ID,
      "documents": o.DOCUMENTS_DRIVE_ID,
      "Shared Documents": o.DOCUMENTS_DRIVE_ID,
    },
    "templateIds": {
      "news": o.NEWS_TEMPLATE_ID
    },
    vivaCommunity: (o.VIVA_COMMUNITY_ID === undefined) ? null : {
      communityLinkPrefix: common.vivaCommunity.communityLinkPrefix,
      communityId: o.VIVA_COMMUNITY_ID
    },
    settingsFilePath: o.SETTINGS_FILE_PATH,
    managerRoles: o.MANAGER_ROLES
  }
}

export const getSiteConfig = (optSitePath) => {
  let sitePath = optSitePath
  if (!sitePath) {
    sitePath = window.location.hostname
    const paths = window.location.pathname.split('/')
    if (paths.length > 1) sitePath = paths[1]
  }
  const site = configMap[sitePath]

  if (!site || !site[Stage]) return {}
  return makeSiteConfig(site[Stage])
}

export const getSiteConfigByItem = (sharepointItem) => {
  const configs = Object.keys(configMap).map(s => {
    return {
      route: s,
      config: makeSiteConfig(configMap[s][Stage])
    }
  })
  const target = configs.find(c => c.config.siteId === sharepointItem.parentReference.siteId)
  return target
}